import Plyr             from 'plyr';
import plyrLocalization from './plyr-l18n.js';

export default class Videos
{
    constructor ( videoContainer )
    {

        this.container = videoContainer;

        this.posterSrc = this.container.dataset?.poster ?? null;
        this.videoSrc  = this.container.dataset?.videoSrc ?? null;

        if ( !this.videoSrc )
        {
            return;
        }

        this.injectVideo();

        this.setupVideoPlayer()


    }

    injectVideo ()
    {
        this.videoElement = document.createElement( 'video' );
        if ( this.posterSrc )
        {
            this.videoElement.setAttribute( 'data-poster', this.posterSrc );
        }

        const videoSrcElement = document.createElement( 'source' );
        videoSrcElement.src   = this.videoSrc;
        videoSrcElement.type  = 'video/mp4';

        this.videoElement.appendChild( videoSrcElement );

        this.container.appendChild( this.videoElement );
    }


    setupVideoPlayer ()
    {
        const playerOptions = {
            i18n   : plyrLocalization,
            poster : this.posterSrc,
        }
        this.playerInstance = new Plyr( this.videoElement, playerOptions );

        this.playerInstance.on( 'ready', ( event ) =>
        {
            setTimeout( () =>
            {

                this.container.classList.add( 'video-ready' );
            }, 300 );
        } );
    }
}
